import * as React from "react";
import { useRouter } from "next/router";
import { IOfferMode } from "@nju/data-access-portal-offers";
import { portalRoutes } from "@nju/routes";

interface IResolveMyAccountPageContextProps {
  type?: "account" | "services" | "reactivation" | "resign";
}

const mappedUrls = {
  account: portalRoutes.mojeKonto.index,
  services: portalRoutes.mojeKonto.mojeUslugi.index,
  reactivation: portalRoutes.mojeKonto.mojeUslugi.reaktywacja.index,
  resign: portalRoutes.mojeKonto.mojeUslugi.zrezygnujZUslugi,
};

export function ResolveMyAccountPageContext({
  children,
  type = "account",
}: IResolveMyAccountPageContextProps & React.PropsWithChildren<unknown>) {
  const router = useRouter();
  const params = portalRoutes.mojeKonto.index.input(router.query).unwrap();
  const resolvedMode =
    params?.mode ||
    ((window.sessionStorage.getItem("mode") || "mobile") as IOfferMode);

  window.sessionStorage.setItem("mode", resolvedMode);

  React.useEffect(() => {
    if (resolvedMode) {
      router.replace(
        mappedUrls[type].get({
          mode: resolvedMode,
          ...(params?.userId && { userId: params?.userId }),
          ...(params?.flow && { flow: params?.flow }),
        }),
      );
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // eslint-disable-next-line unicorn/no-null
  return resolvedMode ? <>{children}</> : null;
}
